import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// GA4 en una SPA solo cuenta la carga inicial: gtag("config") dispara un
// page_view y despues los cambios de ruta de React Router no generan ninguno.
// Sin esto todas las visitas quedan atribuidas a la pagina de entrada y las
// metricas de navegacion interna quedan vacias.
//
// El page_view inicial lo sigue mandando el snippet de index.html, asi que si
// este componente falla las metricas basicas se mantienen igual.
const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  const esPrimera = useRef(true);

  useEffect(() => {
    if (esPrimera.current) {
      esPrimera.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;

    // Esperamos un tick para que Helmet ya haya actualizado el title.
    const id = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);
    return () => clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
